import {FC} from 'react';

import {stakeColumns, useGetEventStakes} from '@entities/stake';
import {MrTable} from '@shared/components';
import {entityTableCommonProps} from '@shared/constants';
import {useUrlState} from '@shared/hooks';

import {PaginationState} from '@/shared/types';

const localStorageKey = 'eventStakesTableV1';
const columns = stakeColumns.filter(
  column => column.accessorKey !== 'eventSlug',
);

interface EventStakesTabProps {
  eventId: string;
}

export const EventStakesTab: FC<EventStakesTabProps> = ({eventId}) => {
  const {urlState, setUrl} = useUrlState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const {
    data,
    isPending: isLoading,
    error,
  } = useGetEventStakes(
    {
      eventId,
      page: urlState.pageIndex + 1,
      pageSize: urlState.pageSize,
    },
    {enabled: Boolean(eventId)},
  );

  return (
    <MrTable
      columns={columns}
      data={data?.items ?? []}
      error={error}
      enableColumnOrdering
      enableColumnDragging={false}
      localStorageKeyForSettings={localStorageKey}
      enableHiding
      enablePagination
      manualPagination
      onPaginationChange={setUrl}
      rowCount={data?.total ?? 0}
      state={{isLoading, pagination: urlState}}
      enableColumnPinning
      initialState={{columnPinning: {left: ['id']}}}
      {...entityTableCommonProps}
      enableRowActions={false}
    />
  );
};
